// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_jspdf_dist_jspdf_es_min_js":"f3ba37d39a1ed900","node_modules_dompurify_dist_purify_es_mjs":"c47ac9e0d6210a11","node_modules_canvg_lib_index_es_js":"f09f9fac6f10cb72"}[chunkId] + ".js";
};